import React, { useState } from "react";

// Popup "clicca la colonna che vuoi mappare": stessa idea di
// SceltaCellaModal.jsx (clicca la cella invece di scrivere il riferimento a
// mano) ma qui per scegliere la COLONNA SORGENTE di un campo di mapping
// (Riga_Articolo, Riga_Variante...) — su file con molte colonne (taglie
// comprese) è facile perdersi tra i nomi in un menu a tendina; vedendo
// l'anteprima vera del file si clicca direttamente quella giusta invece di
// doversi ricordare dove sta "l'articolo" o "la variante".
//
// Click ed evidenzia, non click e chiudi subito: un click sbagliato (colonna
// vicina, riga sbagliata su un file fitto di colonne taglia) altrimenti si
// scopriva solo dopo, guardando il menu a tendina chiuso. Qui la colonna
// scelta resta evidenziata finché non si conferma con "Conferma" (o si
// cambia idea cliccandone un'altra) — così si vede subito cosa si sta per
// applicare, invece di doverlo verificare a modale già chiusa.
export default function SceltaColonnaModal({ nomeFile, etichettaCampo, headers, anteprima, colonnaAttuale, onScegli, onAnnulla }) {
  const righeAnteprima = (anteprima || []).slice(0, 8);
  // Alcuni file hanno colonne senza nome in coda (l'area "usata" del foglio
  // Excel va oltre i dati veri): non sono mappabili su un campo (un nome
  // vuoto non si distinguerebbe da "nessuna colonna scelta"), quindi non
  // hanno senso da cliccare qui. Indice + nome nella chiave React: due
  // colonne con lo stesso nome (capita, file clienti non sempre puliti) non
  // devono collidere.
  const colonne = headers.map((h, indice) => ({ h, indice })).filter((c) => c.h);
  const [colonnaScelta, setColonnaScelta] = useState(colonnaAttuale || null);

  function confermaScelta() {
    if (!colonnaScelta) return;
    onScegli(colonnaScelta);
  }

  return (
    <div
      style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(15, 23, 42, 0.75)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, fontFamily: "Inter, sans-serif" }}
      onClick={onAnnulla}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ backgroundColor: "var(--cf-bg-card)", borderRadius: "16px", width: "920px", maxWidth: "94vw", maxHeight: "88vh", display: "flex", flexDirection: "column", overflow: "hidden", boxShadow: "0 25px 60px rgba(0,0,0,0.45)" }}
      >
        <div style={{ background: "linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)", padding: "18px 22px", display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <span style={{ fontSize: "20px", lineHeight: 1 }}>🖱️</span>
            <div>
              <div style={{ fontFamily: "'Roboto Mono', Consolas, monospace", fontWeight: 700, fontSize: "15px", letterSpacing: "1px", textTransform: "uppercase", color: "#f1f5f9" }}>
                Scegli la colonna per {etichettaCampo}
              </div>
              <div style={{ fontFamily: "'Roboto Mono', Consolas, monospace", fontSize: "11px", color: "var(--cf-text-faint)", letterSpacing: "0.3px", marginTop: "3px" }}>
                {nomeFile}
              </div>
            </div>
          </div>
          <button className="cf-btn" onClick={onAnnulla} style={{ border: "none", background: "rgba(255,255,255,0.08)", borderRadius: "6px", width: "28px", height: "28px", padding: 0, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px", cursor: "pointer", color: "#cbd5e1", lineHeight: 1 }}>
            ✕
          </button>
        </div>

        <div style={{ padding: "20px 24px", overflowY: "auto" }}>
          <p className="testo-secondario" style={{ marginTop: 0 }}>
            Clicca sull'intestazione (o su una qualunque cella) della colonna del file da usare per questo campo, poi
            conferma qui sotto.
          </p>
          <div className="scroll-orizzontale">
            <table className="tabella-anteprima">
              <thead>
                <tr>
                  {colonne.map(({ h, indice }) => {
                    const scelta = h === colonnaScelta;
                    return (
                      <th
                        key={indice}
                        onClick={() => setColonnaScelta(h)}
                        title={`Usa "${h}" per questo campo`}
                        style={{
                          cursor: "pointer",
                          whiteSpace: "nowrap",
                          backgroundColor: scelta ? "#1e3a8a" : undefined,
                          color: scelta ? "#fff" : undefined,
                        }}
                      >
                        {scelta ? "✓ " : ""}{h}
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {righeAnteprima.map((riga, i) => (
                  <tr key={i}>
                    {colonne.map(({ h, indice }) => {
                      const scelta = h === colonnaScelta;
                      const valore = riga[h];
                      const vuota = valore === null || valore === undefined || String(valore).trim() === "";
                      return (
                        <td
                          key={indice}
                          onClick={() => setColonnaScelta(h)}
                          style={{
                            cursor: "pointer",
                            color: vuota ? "var(--cf-text-faint)" : undefined,
                            backgroundColor: scelta ? "rgba(30, 58, 138, 0.18)" : undefined,
                          }}
                          onMouseEnter={(e) => { if (!scelta) e.currentTarget.style.backgroundColor = "rgba(30, 58, 138, 0.08)"; }}
                          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = scelta ? "rgba(30, 58, 138, 0.18)" : ""; }}
                        >
                          {vuota ? "" : String(valore)}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div style={{ padding: "16px 24px", borderTop: "1px solid var(--cf-border)", display: "flex", justifyContent: "space-between", alignItems: "center", gap: "10px", flexShrink: 0 }}>
          <span className="testo-secondario" style={{ fontSize: "12px" }}>
            {colonnaScelta ? <>Colonna scelta: <strong>{colonnaScelta}</strong></> : "Nessuna colonna ancora cliccata"}
          </span>
          <div style={{ display: "flex", gap: "10px" }}>
            <button onClick={onAnnulla}>Annulla</button>
            <button className="btn-primario" onClick={confermaScelta} disabled={!colonnaScelta}>
              ✓ Conferma
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
